import { isSupabaseConfigured } from '../../../lib/services';
import { supabase } from '../../../lib/supabase';
import type { InsuranceClaim, ClaimFormData } from '../types';

export const claimService = {
  async getAll(): Promise<InsuranceClaim[]> {
    if (!isSupabaseConfigured()) {
      const mockClaims: InsuranceClaim[] = [
        {
          id: 'claim-1',
          policy_id: 'policy-1',
          invoice_id: 'invoice-1',
          claim_number: 'CLM-001',
          claim_date: '2024-01-15',
          treatment_date: '2024-01-10',
          diagnosis_code: 'Z00.00',
          treatment_code: 'CPT-99213',
          billed_amount: 150.00,
          approved_amount: 120.00,
          status: 'approved',
          created_at: '2024-01-15T00:00:00Z',
          updated_at: '2024-01-15T00:00:00Z'
        }
      ];
      return mockClaims;
    }
    
    const { data, error } = await supabase
      .from('insurance_claims')
      .select('*')
      .order('created_at', { ascending: false });
    
    if (error) throw error;
    return data as InsuranceClaim[];
  },

  async getById(id: string): Promise<InsuranceClaim | null> {
    if (!isSupabaseConfigured()) {
      return {
        id,
        policy_id: 'policy-1',
        invoice_id: 'invoice-1',
        claim_number: 'CLM-001',
        claim_date: '2024-01-15',
        treatment_date: '2024-01-10',
        diagnosis_code: 'Z00.00',
        treatment_code: 'CPT-99213',
        billed_amount: 150.00,
        approved_amount: 120.00,
        status: 'approved',
        created_at: '2024-01-15T00:00:00Z',
        updated_at: '2024-01-15T00:00:00Z'
      };
    }
    
    const { data, error } = await supabase
      .from('insurance_claims')
      .select('*')
      .eq('id', id)
      .single();
    
    if (error) throw error;
    return data as InsuranceClaim;
  },

  async create(claim: ClaimFormData): Promise<InsuranceClaim> {
    if (!isSupabaseConfigured()) {
      const mockClaim: InsuranceClaim = {
        ...claim,
        id: `claim-${Date.now()}`,
        claim_number: `CLM-${Date.now()}`,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      };
      return mockClaim;
    }
    
    const claimNumber = `CLM-${Date.now()}`;
    
    const { data, error } = await supabase
      .from('insurance_claims')
      .insert([{ 
        ...claim, 
        claim_number: claimNumber,
        updated_at: new Date().toISOString() 
      }])
      .select()
      .single();
    
    if (error) throw error;
    return data as InsuranceClaim;
  },

  async update(id: string, claim: Partial<ClaimFormData>): Promise<InsuranceClaim | null> {
    if (!isSupabaseConfigured()) {
      const existing = await this.getById(id);
      return {
        ...existing!,
        ...claim,
        updated_at: new Date().toISOString()
      };
    }
    
    const { data, error } = await supabase
      .from('insurance_claims')
      .update({ ...claim, updated_at: new Date().toISOString() })
      .eq('id', id)
      .select()
      .single();
    
    if (error) throw error;
    return data as InsuranceClaim;
  }
};
